import React from 'react';
import { Eye, ZoomIn, ZoomOut, FileText } from 'lucide-react';
import PdfViewer from './PdfViewer';

export default function DocumentPreview({ selectedFile, filePreviewUrl, previewType, textContent, zoom, onZoomIn, onZoomOut }) {
  return (
    <div className="w-1/2 bg-slate-950 border-r border-slate-700 flex flex-col">
      <div className="px-4 py-3 border-b border-slate-800 flex items-center justify-between">
        <span className="text-sm font-medium text-slate-300 flex items-center gap-2">
          <Eye className="w-4 h-4" />
          <span>
            Original Document
            {selectedFile?.name ? ` - ${selectedFile.name}` : ''}
          </span>
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={onZoomOut}
            className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-800 rounded transition-colors"
          >
            <ZoomOut className="w-4 h-4" />
          </button>
          <span className="text-xs text-slate-500 w-12 text-center">{zoom}%</span>
          <button
            onClick={onZoomIn}
            className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-800 rounded transition-colors"
          >
            <ZoomIn className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-6 flex items-start justify-center bg-slate-900/50">
        {previewType === 'pdf' && filePreviewUrl ? (
          <PdfViewer src={filePreviewUrl} zoom={zoom} />
        ) : previewType === 'office' && filePreviewUrl ? (
          <div
            style={{
              transform: `scale(${zoom / 100})`,
              transformOrigin: 'top center'
            }}
          >
            <iframe
              src={filePreviewUrl}
              className="bg-white rounded-lg shadow-2xl"
              style={{
                width: `700px`,
                height: `900px`
              }}
              title="Office Document Preview"
              sandbox="allow-scripts allow-same-origin allow-forms"
            />
          </div>
        ) : previewType === 'text' && textContent ? (
          <div className="w-full max-w-4xl">
            <pre
              className="bg-slate-800 text-slate-200 rounded-lg p-6 shadow-2xl whitespace-pre-wrap break-words font-mono leading-relaxed"
              style={{ fontSize: `${14 * zoom / 100}px` }}
            >
              {textContent}
            </pre>
          </div>
        ) : (
          <div className="bg-slate-800 rounded-lg p-8 text-center">
            <FileText className="w-16 h-16 text-slate-600 mx-auto mb-4" />
            <p className="text-slate-400">Document: {selectedFile?.name}</p>
            <p className="text-slate-500 text-sm mt-2">Preview not available for this file type</p>
          </div>
        )}
      </div>
    </div>
  );
}
